import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../styles/naslov.css';

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header className="main-header" style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(15px)',
        padding: '0.5rem 0',
        position: isMobile ? 'fixed' : 'relative',
        top: isMobile ? 0 : 'auto',
        left: isMobile ? 0 : 'auto',
        right: isMobile ? 0 : 'auto',
        zIndex: isMobile ? 99999 : 1000,
        borderBottom: '1px solid #E5E7EB',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <nav className="container main-nav" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative',
          width: '100%',
          boxSizing: 'border-box',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <NavLink to="/" className="logo desktop-nav" style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            fontSize: '1.8rem',
            fontWeight: '800',
            letterSpacing: '-1px',
            textTransform: 'uppercase'
          }}>
            <span style={{ color: '#0072CE' }}>KONTO</span>
            <span style={{ color: '#00c300' }}> ZONA</span>
          </NavLink>

          {/* Mobile Menu Button */}
          {isMobile && (
            <button 
              onClick={toggleMobileMenu}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                padding: '0.5rem',
                color: '#1F2937',
                minWidth: '44px',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10001,
                transition: 'all 0.3s ease',
                borderRadius: '8px'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(0, 195, 0, 0.1)';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.transform = 'scale(1)';
              }}
            >
              {isMobileMenuOpen ? '✕' : '☰'}
            </button>
          )}

          {/* Desktop Navigation */}
          {!isMobile && (
            <ul className="nav-links desktop-nav" style={{
              listStyle: 'none',
              display: 'flex',
              gap: 'clamp(0.5rem, 2vw, 1.5rem)',
              margin: 0,
              padding: 0,
              flex: 1,
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <li>
                <NavLink 
                  to="/" 
                  className={isActive('/') ? 'active' : ''}
                  style={{
                    fontWeight: 500,
                    color: isActive('/') ? '#00c300' : '#1F2937',
                    textDecoration: 'none',
                    padding: '0.5rem 0',
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Naslovna
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/instrukcije" 
                  className={isActive('/instrukcije') ? 'active' : ''}
                  style={{
                    fontWeight: 500,
                    color: isActive('/instrukcije') ? '#00c300' : '#1F2937',
                    textDecoration: 'none',
                    padding: '0.5rem 0',
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Instrukcije
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/skripte" 
                  className={isActive('/skripte') ? 'active' : ''}
                  style={{
                    fontWeight: 500,
                    color: isActive('/skripte') ? '#00c300' : '#1F2937',
                    textDecoration: 'none',
                    padding: '0.5rem 0',
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Skripte
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/faq" 
                  className={isActive('/faq') ? 'active' : ''}
                  style={{
                    fontWeight: 500,
                    color: isActive('/faq') ? '#00c300' : '#1F2937',
                    textDecoration: 'none',
                    padding: '0.5rem 0',
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  FAQ
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/kontakt" 
                  className={isActive('/kontakt') ? 'active' : ''}
                  style={{
                    fontWeight: 500,
                    color: isActive('/kontakt') ? '#00c300' : '#1F2937',
                    textDecoration: 'none',
                    padding: '0.5rem 0',
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Kontakt
                </NavLink>
              </li>
            </ul>
          )}

          {/* Desktop Social Media Buttons */}
          {!isMobile && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              flexShrink: 0
            }}>
              <a 
                href="https://wa.me/385976666639" 
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary desktop-cta"
                style={{
                  padding: 'clamp(8px, 2vw, 12px) clamp(12px, 2.5vw, 20px)',
                  fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: '#00c300',
                  color: 'white',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  minWidth: '44px',
                  minHeight: '44px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 195, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <i className="fab fa-whatsapp" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a 
                href="https://www.instagram.com/konto.zona/" 
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary desktop-cta"
                style={{
                  padding: 'clamp(8px, 2vw, 12px) clamp(12px, 2.5vw, 20px)',
                  fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                  color: 'white',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  minWidth: '44px',
                  minHeight: '44px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(188, 24, 136, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <i className="fab fa-instagram" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61584401916262" 
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary desktop-cta"
                style={{
                  padding: 'clamp(8px, 2vw, 12px) clamp(12px, 2.5vw, 20px)',
                  fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: '#1877F2',
                  color: 'white',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  minWidth: '44px',
                  minHeight: '44px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(24, 119, 242, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <i className="fab fa-facebook" style={{ fontSize: '1.5rem' }}></i>
              </a>
            </div>
          )}
        </nav>
      </header>

      {/* Mobile Navigation Menu - Fixed Position with Animations */}
      {isMobile && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: isMobileMenuOpen ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          paddingTop: '80px',
          opacity: isMobileMenuOpen ? 1 : 0,
          visibility: isMobileMenuOpen ? 'visible' : 'hidden',
          transition: 'all 0.3s ease'
        }}>
          <div style={{
            background: 'white',
            width: '280px',
            height: '100vh',
            padding: '2rem 1rem',
            boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.15)',
            overflowY: 'auto',
            transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
            transition: 'transform 0.3s ease',
            borderTopLeftRadius: '20px',
            borderBottomLeftRadius: '20px'
          }}>
            {/* Close Button */}
            <button 
              onClick={closeMobileMenu}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#6B7280',
                padding: '0.5rem',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(0, 195, 0, 0.1)';
                e.target.style.color = '#00c300';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.color = '#6B7280';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ✕
            </button>

            {/* Logo in Mobile Menu */}
            <div style={{ 
              textAlign: 'center', 
              marginBottom: '2rem',
              paddingTop: '1rem'
            }}>
              <div style={{
                fontSize: '1.6rem',
                fontWeight: '800',
                letterSpacing: '-1px',
                textTransform: 'uppercase'
              }}>
                <span style={{ color: '#0072CE' }}>KONTO</span>
                <span style={{ color: '#00c300' }}> ZONA</span>
              </div>
            </div>

            <ul style={{
              listStyle: 'none',
              margin: 0,
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}>
              {[
                { to: '/', label: 'Naslovna' },
                { to: '/instrukcije', label: 'Instrukcije' },
                { to: '/skripte', label: 'Skripte' },
                { to: '/faq', label: 'FAQ' },
                { to: '/kontakt', label: 'Kontakt' }
              ].map((link, index) => (
                <li key={link.to} style={{
                  opacity: isMobileMenuOpen ? 1 : 0,
                  transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(20px)',
                  transition: `all 0.3s ease ${index * 0.1}s`
                }}>
                  <NavLink 
                    to={link.to} 
                    className={isActive(link.to) ? 'active' : ''}
                    onClick={closeMobileMenu}
                    style={{
                      color: isActive(link.to) ? '#00c300' : '#1F2937',
                      fontWeight: isActive(link.to) ? 600 : 500,
                      textDecoration: 'none',
                      padding: '1rem',
                      display: 'block',
                      transition: 'all 0.3s ease',
                      borderRadius: '12px',
                      fontSize: '1.1rem',
                      background: isActive(link.to) ? 'rgba(0, 195, 0, 0.1)' : 'transparent',
                      border: isActive(link.to) ? '2px solid #00c300' : '2px solid transparent'
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive(link.to)) {
                        e.target.style.background = 'rgba(0, 195, 0, 0.05)';
                        e.target.style.transform = 'translateX(5px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive(link.to)) {
                        e.target.style.background = 'transparent';
                        e.target.style.transform = 'translateX(0)';
                      }
                    }}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
            
            {/* Mobile Social Media Buttons */}
            <div style={{ 
              marginTop: '2rem', 
              padding: '0 1rem',
              opacity: isMobileMenuOpen ? 1 : 0,
              transform: isMobileMenuOpen ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.3s ease 0.4s',
              display: 'flex',
              gap: '0.75rem',
              justifyContent: 'center'
            }}>
              <a 
                href="https://wa.me/385976666639" 
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                style={{
                  display: 'flex',
                  padding: '1rem',
                  fontSize: '1.2rem',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: '#00c300',
                  color: 'white',
                  textDecoration: 'none',
                  width: '56px',
                  height: '56px',
                  boxShadow: '0 4px 15px rgba(0, 195, 0, 0.3)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 195, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 195, 0, 0.3)';
                }}
              >
                <i className="fab fa-whatsapp" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a 
                href="https://www.instagram.com/konto.zona/" 
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                style={{
                  display: 'flex',
                  padding: '1rem',
                  fontSize: '1.2rem',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                  color: 'white',
                  textDecoration: 'none',
                  width: '56px',
                  height: '56px',
                  boxShadow: '0 4px 15px rgba(188, 24, 136, 0.3)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(188, 24, 136, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(188, 24, 136, 0.3)';
                }}
              >
                <i className="fab fa-instagram" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61584401916262" 
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                style={{
                  display: 'flex',
                  padding: '1rem',
                  fontSize: '1.2rem',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: '#1877F2',
                  color: 'white',
                  textDecoration: 'none',
                  width: '56px',
                  height: '56px',
                  boxShadow: '0 4px 15px rgba(24, 119, 242, 0.3)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(24, 119, 242, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(24, 119, 242, 0.3)';
                }}
              >
                <i className="fab fa-facebook" style={{ fontSize: '1.5rem' }}></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header; 